import React from 'react';
import { useStyletron } from 'baseui';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { LabelMedium } from 'baseui/typography';
import { RELATIONSHIP_CONSTANTS } from '../../constants';
import { RELATIONSHIP_TOOLTIP_OVERRIDES } from '../../overrides';
import type { RelationshipT } from '../../types/relationship';
import { CreateRelationshipButton } from '../create-relationship-button';
import RelationshipsList from './relationship-list';
type RelationshipSectionProps = {
  relationships: RelationshipT[];
  getTargetDisplayName: (annotationId: string) => string;
  onCreateRelationship: () => void;
  onEditRelationship: (relationshipId: string) => void;
  onDeleteRelationship: (relationshipId: string) => void;
  isVideoTask?: boolean;
  readOnly?: boolean;
  disabledReason?: string;
};
const RelationshipSection = ({
  relationships,
  getTargetDisplayName,
  onCreateRelationship,
  onEditRelationship,
  onDeleteRelationship,
  isVideoTask,
  readOnly,
  disabledReason
}: RelationshipSectionProps) => {
  const [css] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'column'
  })}>
      <div className={css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    })}>
        <LabelMedium margin={0}>{RELATIONSHIP_CONSTANTS.SECTION_TITLE}</LabelMedium>
        {!readOnly && (!!disabledReason ? <StatefulTooltip content={disabledReason} overrides={RELATIONSHIP_TOOLTIP_OVERRIDES} placement={PLACEMENT.top} showArrow>
              <span>
                <CreateRelationshipButton disabled label={RELATIONSHIP_CONSTANTS.CREATE_BUTTON} variant="button" />
              </span>
            </StatefulTooltip> : <CreateRelationshipButton label={RELATIONSHIP_CONSTANTS.CREATE_BUTTON} onClick={onCreateRelationship} variant="button" />)}
      </div>

      <RelationshipsList relationships={relationships} getTargetDisplayName={getTargetDisplayName} onEdit={onEditRelationship} onDelete={onDeleteRelationship} isVideoTask={isVideoTask} readOnly={readOnly} />
    </div>;
};
export default RelationshipSection;